module.exports = __webpack_public_path__ + "static/media/answer_zh.3866af0b.png";